import Grid from "@mui/material/Grid";

import GCAutocompleteCheckbox from "../../../Component/Common/ReuseableComponent/GCAutocompleteCheckbox";
import {
  CmpTypographyField,
  CmpSelectField,
  CmpDatePickerField,
  CmpRadioButton,
} from "../../../Component/Common/ToolBox/ToolBox.js";

export default function WmsHead({
  fLocation_MultiSelect,
  sLocationData,

  //multiselect
  sWebStockReportData,
  sWebStockReportArr,

  HeadObject,
  fLocation,
  fFromDate,
  fToDate,
  fDate,
  sWebBetweenReportArr,
  fReportType,
}) {
  return (
    <form id="BranchToDcTsrDetailReportHead">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 1 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className="d-flex align-items-center"
        >
          <CmpTypographyField
            xcomponent={"h1"}
            xText={"Branch To DC - TSR Detail Report"}
            xfontSize="20px"
            xtextDecoration="underline"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Location"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"01"}
                xLabelText="sLocation"
                xValue={HeadObject.sLocation}
                xOnChange={fLocation}
                xName={"sLocation"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={true}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"02"}
                options={sLocationData}
                xDisabled={
                  HeadObject?.sLocation?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sLocationArr}
                setValue={fLocation_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Purchase Date"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"01"}
                xLabelText="sDate"
                xValue={HeadObject.sDate}
                xOnChange={fDate}
                xName={"sDate"}
                xData={sWebBetweenReportArr}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={true}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={4} lg={4}>
              <CmpDatePickerField
                xValue={HeadObject.sFromDate}
                xOnChange={fFromDate}
                xName={"sFromDate"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={4} lg={4}>
              <CmpDatePickerField
                xValue={HeadObject.sToDate}
                xOnChange={fToDate}
                xName={"sToDate"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Report Type"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1.5} lg={1.5}>
              <CmpRadioButton
                value="PENDING"
                label="Pending"
                checked={HeadObject.sReportType === "PENDING"}
                onChange={fReportType}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={1.5} lg={1.5}>
              <CmpRadioButton
                value="PROGRESS"
                label="Progress"
                checked={HeadObject.sReportType === "PROGRESS"}
                onChange={fReportType}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={1.5} lg={1.5}>
              <CmpRadioButton
                value="HISTORY"
                label="History"
                checked={HeadObject.sReportType === "HISTORY"}
                onChange={fReportType}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={2} lg={2}>
              <CmpRadioButton
                value="PENDING_DETAIL"
                label="Pending Detail"
                checked={HeadObject.sReportType === "PENDING_DETAIL"}
                onChange={fReportType}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
